/**
 * Extracción de métricas de dosis desde cabeceras DICOM de imagen CT/RX.
 */

function str(ds, tag) {
  if (!ds || typeof ds.string !== 'function') return null
  try {
    const v = ds.string(tag)
    return v != null && String(v).trim() ? String(v).trim() : null
  } catch (e) {
    return null
  }
}

function num(ds, tag) {
  const v = str(ds, tag)
  if (v == null) return null
  const n = parseFloat(String(v).split('\\')[0])
  return Number.isFinite(n) ? n : null
}

/**
 * @param {object|null} image Cornerstone image con dataSet
 * @returns {{
 *   ctdivol: number|null,
 *   dlp: number|null,
 *   dap: number|null,
 *   kvp: number|null,
 *   ma: number|null,
 *   mas: number|null,
 *   exposureTime: number|null,
 *   source: string,
 * }}
 */
export function doseFromImageHeaders(image) {
  const empty = {
    ctdivol: null,
    dlp: null,
    dap: null,
    kvp: null,
    ma: null,
    mas: null,
    exposureTime: null,
    source: 'headers',
  }
  if (!image || !image.data) return empty
  const ds = image.data

  // CTDIvol (0018,9345) Enhanced CT; también en algunas series como DS en otros tags
  let ctdivol = num(ds, 'x00189345')
  if (ctdivol == null) ctdivol = num(ds, 'x00180046') // fallback raro

  // DLP a menudo solo en RDSR; algunos vendors en privado — no inventamos
  const dlp = null

  // DAP / Dose Area Product (0018,115E)
  let dap = num(ds, 'x0018115e')

  const kvp = num(ds, 'x00180060')
  const exposureTime = num(ds, 'x00181150')
  let ma = num(ds, 'x00181151') // X-Ray Tube Current
  let mas = num(ds, 'x00181152') // Exposure
  if (mas == null && ma != null && exposureTime != null) {
    // Exposure Time en ms → mAs ≈ mA * s
    mas = ma * (exposureTime / 1000)
  }

  return {
    ctdivol,
    dlp,
    dap,
    kvp,
    ma,
    mas,
    exposureTime,
    source: 'headers',
  }
}

/**
 * Agrega dosis de un file item (primera imagen decodificada).
 * @param {object} fileItem
 */
export function doseFromFileItem(fileItem) {
  const image = fileItem && fileItem.image
  const metrics = doseFromImageHeaders(image)
  return {
    ...metrics,
    seriesNumber: fileItem && fileItem.series && fileItem.series.seriesNumber,
    seriesDescription:
      (fileItem && fileItem.series && fileItem.series.seriesDescription) || '',
    modality: (fileItem && fileItem.series && fileItem.series.modality) || '',
  }
}
